import { initializeStore } from '@seamless/store'
import {
  initializeWkoManager,
  connectionName as wkoConnectionName,
  WellKnownObjects,
} from '@owc/connection-wko-manager'
import { initDemoConfig } from '@/demo'

export const seamlessStore = initializeStore()

const countriesLanguageRequired = ['XA', 'BE', 'XD', 'CH', 'TH', 'LU']
const inboxBaseURL = '/passengercars/my-area/my-inbox.html'

let oneWebWKOs: WellKnownObjects | null = null
export let jwe = ''

export async function getOneWebLocale(): Promise<string> {
  return buildLocale(oneWebWKOs ?? (await getOneWebWKOs()))
}

const buildLocale = (objectwko: WellKnownObjects) => `${objectwko.Locale?.language}-${objectwko.Locale?.country}`

// Well-Known-Objects
export async function getOneWebWKOs(): Promise<WellKnownObjects> {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve: (value: WellKnownObjects) => void) => {
    // when using demo.html for testing directly in the assets server
    !window.notificationsHubStandaloneMode || (await initDemoConfig())

    // initializes WKO Manager (gets WKOs data and creates/puts in store)
    await initializeWkoManager()
    await seamlessStore.subscribe(wkoConnectionName, (wkos: WellKnownObjects) => {
      oneWebWKOs = wkos
      resolve(wkos)
    })
  })
}

export const setJWE = (b2xJWE: string | null): string => (jwe = b2xJWE ?? '')

export const buildInboxURL = (): string => {
  const country = oneWebWKOs?.Locale?.country ?? ''
  if (countriesLanguageRequired.includes(country)) {
    const language = oneWebWKOs?.Locale?.language ?? ''
    return `/${country === 'BE' && language === 'nl' ? 'nl_BE' : language}${inboxBaseURL}`
  }
  return inboxBaseURL
}
